export default {
  ir: 'Farsi',
  in: 'Hindi',
  ne: 'Nepali',
  pa: 'Punjabi',
  ur: 'Urdu',
  ru: 'Russian',
  te: 'Telugu',
  cn: 'Chinese',
  ta: 'Tamil',
  ka: 'Georgian',
  ar: 'Arabic',
}
